import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=200f7e1c"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=200f7e1c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200f7e1c')) {
      api.createRecord('200f7e1c', component.options)
    } else {
      api.reload('200f7e1c', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=200f7e1c", function () {
      api.rerender('200f7e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/cuenta/Form.vue"
export default component.exports